<template>
    <sections>
        <section-locations heading="Contact"></section-locations>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Contact | ' + $config.public.siteName,
    description: 'Whatever your requirements, we are here to help!',
    index: true,
});
</script>
